/* eslint-disable no-unsafe-optional-chaining */
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'raceResult',
  standalone: true
})
export class RaceResultPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(objData: any, type: string, arg1: any, poolType?: string): string {
    let toReturn: string = '-';

    switch (type) {
      case 'MAIN': {
        if (poolType === 'WIN') toReturn = this.getDataResult(objData, arg1, poolType);
        else if (poolType === 'PLC') toReturn = this.getDataResult(objData, arg1, poolType);
        else if (poolType === 'SHW') toReturn = this.getDataResult(objData, arg1, poolType);
        break;
      }
      case 'POOL': {
        toReturn = this.getPool(objData, arg1?.PoolId);
        break;
      }
    }

    return toReturn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPool(poolsTotal: any, poolId: string): string {
    // if (poolId === 'DBL') return '-';

    const pool = _.find(
      poolsTotal,
      (poolTotal) => (poolTotal?.Id === poolId) ? poolTotal : undefined
    );

    return pool?.Handle
      ? '$ ' + pool?.Handle.toFixed()
      : '-'
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataResult(objData: any, runner: any, type: string): string {
    let toReturn: string = '-';

    for (const pool of objData?.PoolPrices) {
      if (pool?.PoolId === type) {
        if (pool?.Refund) toReturn = 'Refund';
        else {
          for (const price of pool?.Prices) {
            if (price?.Finish === String(runner?.RunnerId)) {
              toReturn = String(((price?.PriceAmount||0)/((price?.Wager||0)/2)).toFixed(2));
            }
          }
        }
      }
    }

    return toReturn;
  }

}
